var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSonic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.1997 93.2521C62.1077 101.688 38.8697 113.994 24.3197 128.412L23.6777 129.054C27.5477 132.714 31.7897 135.99 36.3737 138.774L37.3577 137.568C41.3297 132.714 45.5897 128.028 50.0237 123.612C61.9277 111.75 75.5477 101.484 90.2117 93.2401L90.1937 93.2521H90.1997Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.709961 80.7541C1.83196 95.7961 7.41796 109.59 16.184 120.81L16.586 120.408C25.5919 111.522 37.3159 103.446 51.4579 96.4081C63.8539 90.2341 78.0859 84.9361 93.4279 80.7541H0.709961Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.884 18.9301C83.018 43.9741 114.65 60.5341 149.348 66.8161C145.16 29.6881 113.558 0.804062 75.164 0.804062C65.024 0.804062 55.358 2.82606 46.532 6.47406C50.114 10.7881 53.942 14.9881 57.884 18.9301Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3198 21.9961C38.8698 36.4321 62.1078 48.7201 90.1998 57.1741C75.5358 48.9181 61.9158 38.6641 50.0118 26.8021C45.5898 22.3981 41.3358 17.7121 37.3458 12.8461L36.3618 11.6401C31.7778 14.4241 27.5358 17.6941 23.6838 21.3541L24.3258 21.9961H24.3198Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.884 131.478C53.924 135.42 50.102 139.62 46.532 143.934C55.346 147.582 65.024 149.604 75.164 149.604C113.564 149.604 145.166 120.72 149.36 83.5801C114.668 89.8621 83.036 106.422 57.896 131.466L57.884 131.478Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4579 54.0001C37.3159 46.9621 25.5919 38.8801 16.586 30.0001L16.184 29.5981C7.41796 40.8181 1.83196 54.6121 0.709961 69.6541H93.4099C78.0739 65.472 63.8539 60.174 51.4399 53.982L51.4519 54.0001H51.4579Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonic);
export default __webpack_public_path__ + "static/media/sonic.554d23f0cbc80ef0a8c1a32dda77bed5.svg";
export { ForwardRef as ReactComponent };